// Import components.
import Goal from './components/Goal.jsx';

/**
 * <pre>
 * Goal module React Components.
 *
 * Summary of responsibilities:
 *
 *  - defines React components that this app module can render
 * </pre>
 *
 * @author Tim Loram
 *
 * @memberof module:Goal
 * @namespace
 *
 * @type {Object}
 */
const Components = {
	Goal: Goal
};

export default Components;